import React from 'react';

const FaturamentoContext = React.createContext();

export default FaturamentoContext;
